/**
 * @file formSettings.tsx
 *
 * @fileoverview Helper methods for getting settings for fields.
 */

import { EntityField } from '~/jobiqo/models/entity';

/**
 * Gets a setting value from the settings property.
 *
 * @param {string} name
 *   The name of the setting to get.
 * @param {EntityField} field
 *   The field from which to read the number of rows from.
 *
 * @returns {number}
 *   The number of rows in the field settings.
 */
export const getSetting = (name: string, field: EntityField) => {
  const setting = field.settings.filter((fieldSetting) => {
    return fieldSetting.key === name;
  });
  if (setting.length > 0 && setting[0].value) {
    return setting[0].value;
  }
  return null;
};

/**
 * Gets the placeholder value for a field.
 *
 * @param {EntityField} field
 *   The field from which to read the number of rows from.
 *
 * @returns {string||null}
 *   Returns the placeholder or null if there is none.
 */
export const getPlaceholder = (field: EntityField): string => {
  const settings = getSetting('form_settings', field);
  if (settings && settings.placeholder) {
    return settings.placeholder;
  }
  return '';
};
